// extracted by mini-css-extract-plugin
module.exports = {"FpxTab":"FpxTab--FpxTab--1ZfqUDD"};